<template>
  <div class="container iconos dkt mt-3 d-none d-md-block">
    <table class="table table-sm table-borderless mt-2">
      <tbody>
        <tr>
          <th scope="col" colspan="2" rowspan="2" class="text-left ml-3">
            <!--<a href="https://www.aiep.cl/" class="img-fluid w-50 ml-3" target="_blank">
              <img
                :src="getUrlImagen"
                style="max-width: 4rem; margin: .5rem;"
              />
            </a>-->
            <LogoInstitucion
              :idLogo="urlLogo"
              :urlWeb="web"
              classContenedora="img-fluid w-50 ml-3"
              styleImg="max-width: 8rem; margin: .5rem;"
            />
          </th>
          <th scope="col">
            <!--<AñosAcreditacion
              :acreditacion="acreditacion.anios"
              classImg="mr-3"
              styleImg="width: 28px; margin: .5rem;"
            />-->
            <img
              src="@/assets/img/iconos/acreditacion-8.svg"
              class="mr-3"
              style="width: 28px; margin: 0.5rem"
            />
          </th>
          <td scope="col" class="border-right pr-2">
            {{ textoAcreditacion }}
            <img
              src="@/assets/img/asterisk-solid.svg"
              v-if="leyExcepcion || acreditacionEspecialPandemiaCNA"
              style="width: 0.5rem; margin: 0.4rem"
            />
          </td>
          <th scope="col" class="pr-2">
            <FontAwesomeIcon icon="map-marker-alt" class="mx-2" />
          </th>
          <td scope="col" class="border-right">
            <div v-html="textoSedeRegion" class="ml-2">
              <!--<strong>{{ sede.nombre }}</strong>
              <br />
              {{ sede.regionNombreCorto }}-->
            </div>
          </td>
          <th scope="col" class="text-center">
            <FontAwesomeIcon icon="mobile-alt" class="mr-2" />
          </th>
          <td scope="col">
            <div class="ml-2">{{ textoTelefono }}</div>
          </td>
        </tr>
        <tr class="no-print">
          <td scope="row" colspan="4">&nbsp;</td>
          <th scope="row" class="text-center border-left">
            <FontAwesomeIcon icon="laptop" class="mr-2" />
          </th>
          <td>
            <div class="ml-2">
              <a :href="web" class="text-negro" target="_blank"
                >Ver Sitio Web</a
              >
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">
            <PostulacionTP
              :postulacion="sede.carreras[0].estadoPostulacion"
              classImg="mr-3"
              styleImg="width: 28px; margin: .5rem .75rem;"
              :tooltipDisabled="true"
            />
          </th>
          <td>
            <div class="ml-2">{{ textoPostulacion }}</div>
          </td>
          <th>
            <img
              src="@/assets/img/iconos/calendario.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td>Duración {{ textoDuracion }}</td>
          <th scope="row">
            <img
              src="@/assets/img/iconos/arancel-1.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td>
            <div>
              Arancel {{ anioArancelTP }}:
              {{
                formatearArancelMatricula(
                  sede.carreras[0].arancelAnual,
                  sede.carreras[0].tipoMoneda
                )
              }}
            </div>
          </td>
          <th scope="row">
            <Jornada
              :jornada="sede.carreras[0].jornada"
              :tooltipDisabled="true"
              styleImg="width: 28px; margin: .5rem .75rem;"
              classImg="mr-3"
            />
          </th>
          <td>
            <div class="ml-2">{{ textoJornada }}</div>
          </td>
        </tr>
        <tr>
          <th scope="row" class="no-print">
            <img
              src="@/assets/img/iconos/malla-curricular.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td class="no-print">
            <div class="ml-2">
              <a
                :href="sede.carreras[0].urlMallaCurricular"
                target="_blank"
                class="text-negro"
                alt="Ver malla curricular"
                >Ver Malla Curricular</a
              >
            </div>
          </td>
          <th>
            <img
              src="@/assets/img/iconos/calendario.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td>
            Inicio Admisión:
            {{
              sede.carreras[0].fechaAdmision !== "01/01/2000"
                ? sede.carreras[0].fechaAdmision
                : "S/I"
            }}
          </td>
          <th scope="row">
            <img
              src="@/assets/img/iconos/vacantes.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td>
            <div>
              Vacantes {{ anioVacanteTP }}: {{ sede.carreras[0].vacantes }}
            </div>
          </td>
          <th scope="row" v-if="mostrarVacantesPACE">
            <img
              src="@/assets/img/iconos/vacantes.svg"
              style="width: 28px; margin: 0.5rem 0.75rem"
              class="mr-3"
            />
          </th>
          <td v-if="mostrarVacantesPACE">
            <div class="ml-2">
              Vacantes PACE: {{ sede.carreras[0].vacantesPACE }}
            </div>
          </td>
          <td scope="row">&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <div
      class="col col-md-12 d-block pl-3 pr-5 mr-auto"
      v-if="leyExcepcion || acreditacionEspecialPandemiaCNA"
    >
      <p v-if="leyExcepcion" class="text-muted">
        <small>
          <img
            src="@/assets/img/asterisk-solid.svg"
            style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
            class="mr-2"
          />
          Los Centros de Formación Técnica estatales creados por Ley 20.910
          deben someterse a acreditación ante la CNA en un plazo máximo de seis
          años contados desde el inicio de sus actividades académicas.
        </small>
      </p>
      <p v-if="acreditacionEspecialPandemiaCNA" class="text-muted">
        <small>
          <img
            src="@/assets/img/asterisk-solid.svg"
            style="width: 0.5rem; margin: 0.3rem 0.3rem 0.3rem 0"
            class="mr-2"
          />
          Acreditación prorrogada en virtud de resolución exenta DJ Nº 051-4.
          <a :href="linkResoulucion" target="_blank">Haz clic aquí</a>, para más
          información.
        </small>
      </p>
    </div>
  </div>
</template>

<script>
import AñosAcreditacion from "@/components/generales/iconos/AniosAcreditacion";
import Jornada from "@/components/generales/iconos/Jornada";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapMarkerAlt,
  faLaptop,
  faMobileAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Busqueda from "@/utils/Busqueda.js";
import PostulacionTP from "@/components/generales/iconos/PostulacionTP";
import LogoInstitucion from "@/components/generales/iconos/LogoInstitucion";
import MixinArancelMatricula from "@/mixins/FormatearArancelMatricula.js";
library.add(faMapMarkerAlt, faMobileAlt, faLaptop);
export default {
  name: "IconosDesktop",
  mixins: [MixinArancelMatricula],
  props: {
    acreditacion: { type: Object },
    acreditado: { type: Boolean },
    //gratuidad: { type: Boolean },
    sede: { type: Object },
    web: { type: String },
    urlLogo: { type: Number },
    telefono: "",
    leyExcepcion: { type: Boolean }
  },
  components: {
    FontAwesomeIcon,
    AñosAcreditacion,
    PostulacionTP,
    Jornada,
    Gratuidad,
    LogoInstitucion
  },
  data() {
    return {
      linkResoulucion: CDN.RESOLUCION_COVID_ACREDITACION
    };
  },
  computed: {
    mostrarVacantesPACE() {
      return this.sede.carreras[0].vacantesPACE > 0;
    },
    textoPostulacion() {
      let text = "";
      switch (this.sede.carreras[0].estadoPostulacion) {
        case "ABIERTA":
          text = "Postulaciones Abiertas";
          break;
        case "CERRADA":
          text = "Postulaciones Cerradas";
          break;
        case "LISTA_DE_ESPERA":
          text = "Postulaciones en Lista de Espera";
          break;
        default:
          break;
      }
      return text;
    },
    textoJornada() {
      let text = "";
      switch (this.sede.carreras[0].jornada) {
        case "DIURNO":
          text = "Presencial Diurna";
          break;
        case "VESPERTINO":
          text = "Presencial Vespertina";
          break;
        case "A_DISTANCIA":
          text = "A Distancia";
          break;
        case "SEMIPRESENCIAL":
          text = "Semipresencial";
          break;
        default:
          break;
      }
      return text;
    },
    /*textoGratuidad() {
      let texto = "";
      if (this.gratuidad) {
        texto = "Adscrita a gratuidad";
      } else {
        texto = "No Adscrita a gratuidad";
      }
      return texto;
    },*/
    textoDuracion() {
      if (
        this.sede.carreras[0].duracionFormalPrograma &&
        this.sede.carreras[0].regimen
      ) {
        let duracion = this.sede.carreras[0].duracionFormalPrograma;
        let textoRegimen = this.sede.carreras[0].regimen;
        let textoRegimenNuevo =
          textoRegimen.charAt(0) + textoRegimen.slice(1).toLowerCase();
        return `${duracion} ${textoRegimenNuevo}`;
      } else {
        return "No Disponible";
      }
    },
    acreditacionEspecialPandemiaCNA() {
      return this.acreditado && this.acreditacion.anios === 0;
    },
    textoAcreditacion() {
      if (this.acreditado) {
        if (this.acreditacionEspecialPandemiaCNA) {
          return "Acreditado";
        } else {
          return `Acreditación Institucional ${this.acreditacion.anios} ${
            this.acreditacion.anios > 1 ? "años" : "año"
          }`;
        }
      } else if (this.leyExcepcion) {
        return "Bajo Tutela";
      } else {
        return "No Acreditado";
      }
    },
    textoTelefono() {
      let numeroString = this.telefono.toString();
      if (
        numeroString.substring(0, 3) === "800" ||
        numeroString.substring(0, 3) === "600"
      ) {
        return this.telefono;
      } else {
        return "+56 " + this.telefono;
      }
    },
    textoSedeRegion() {
      if (this.sede.carreras[0].jornada === "A_DISTANCIA") {
        return "<strong>Aula Virtual</strong><br/> - ";
      } else {
        return `<strong>${this.sede.nombre}</strong>
              <br />
              ${this.sede.regionNombreCorto}`;
      }
    }
  },
  methods: {
    limpiarNombreRegion(region) {
      return Busqueda.limpiarNombreRegionSimble(region);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/fichaCarreraTP/IconosDesktop.vue